const REGEX_CPF_CNPJ_FORMAT = /[0-9A-Z]/g;

const formatNumber = (input, decimalPlaces) => {
    if (input === null || input === undefined) return '-';
    input = parseFloat(input);
    return input.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces
    });
};

const numeralStringFormatToDocumento = numeralString => {
    if (!numeralString) return '';

    if (numeralString.length === 11) {
        return mascaraCpf(numeralString);
    } else if (numeralString.length === 14) {
        return mascaraCnpj(numeralString);
    } else if (numeralString.length === 8 || numeralString.length === 9) {
        return mascaraRuc(numeralString);
    } else {
        return numeralString;
    }
};

const maxFormatNumber = (input, decimalPlaces, isDashboard) => {
    if (!input) {
        return isDashboard ? '0' : '-';
    }
    input = parseFloat(input);
    return input.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces
    });
};

const formatNumberUs = (input, decimalPlaces) => {
    if (!input) {
        return '0';
    }

    const inputString = String(input);
    if (inputString.includes('.')) {
        let n = inputString.split('.', decimalPlaces);
        input =
            n[0] +
            '.' +
            n[1]
                .substr(0, n[1].length - (n[1].length - decimalPlaces))
                .padEnd(decimalPlaces, '0');
    }
    const options = {
        style: 'decimal',
        currency: 'BRL'
    };
    const formatNumber = new Intl.NumberFormat('en-US', options);
    return formatNumber.format(input).replace(/,/g, '.');
};

const formatProdutividade = produtividade => {
    if (!produtividade) return null;

    const options = {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };

    const formatNumber = new Intl.NumberFormat('pt-BR', options);
    const resultado = Number.parseFloat(produtividade);

    if (resultado === 0) {
        return '-';
    }

    const variacao = 0.05; // 5%

    return `${formatNumber.format(
        resultado - resultado * variacao
    )} a ${formatNumber.format(resultado + resultado * variacao)}`;
};

const formatRoundProdutividade = value => {
    if (!value) return null;

    const resultado = Number.parseFloat(value);

    if (resultado === 0) {
        return '-';
    }

    const variacao = 0.05; // 5%

    return `${Math.ceil(resultado - resultado * variacao)} a ${Math.ceil(
        resultado + resultado * variacao
    )}`;
};

const cpfCnpjFormatToNumeral = cpfCnpj => {
    const value = cpfCnpj.replace(REGEX_CPF_CNPJ_FORMAT, '');
    if (
        value &&
        (value.length === 11 ||
            value.length === 14 ||
            value.length === 8 ||
            value.length === 9) &&
        Number(value)
    ) {
        return value;
    }

    return cpfCnpj;
};

const numeralStringFormatTocpfCnpj = (numeralString, pais) => {
    if (!numeralString) return '';

    if (pais === 'AR') {
        return formatarCuit(numeralString);
    } else if (pais === 'PY') {
        return mascaraRuc(numeralString);
    } else if (numeralString.length === 11 || pais === 'BR') {
        return mascaraCpf(numeralString);
    } else if (numeralString.length === 14 || pais === 'BR') {
        return mascaraCnpj(numeralString);
    } else {
        return numeralString;
    }
};

function mascaraRuc(valor) {
    const string = String(valor || '').replace(/\D/g, '');
    if (!string.length) return '';

    const partes = [
        string.substring(0, string.length - 1),
        string.substring(string.length - 1)
    ];

    return partes.join('-');
}

function mascaraCpf(valor) {
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/^(-\d{2})(\d)$/, '$1');
}

function mascaraCnpj(valor) {
    const cleanValor = valor.replace(/[^A-Z0-9]/gi, '');
    
    return `${cleanValor.substring(0, 2)}.${cleanValor.substring(2, 5)}.${cleanValor.substring(5, 8)}/${cleanValor.substring(8, 12)}-${cleanValor.substring(12)}`;
}

function utf8Decode(utf8String) {
    // eslint-disable-next-line eqeqeq
    if (typeof utf8String != 'string') {
        throw new TypeError('parameter ‘utf8String’ is not a string');
    }
    const unicodeString = utf8String
        .replace(
            /[\u00e0-\u00ef][\u0080-\u00bf][\u0080-\u00bf]/g,
            function (c) {
                var cc =
                    ((c.charCodeAt(0) & 0x0f) << 12) |
                    ((c.charCodeAt(1) & 0x3f) << 6) |
                    (c.charCodeAt(2) & 0x3f);
                return String.fromCharCode(cc);
            }
        )
        .replace(/[\u00c0-\u00df][\u0080-\u00bf]/g, function (c) {
            var cc = ((c.charCodeAt(0) & 0x1f) << 6) | (c.charCodeAt(1) & 0x3f);
            return String.fromCharCode(cc);
        });
    return unicodeString;
}

function formatCar(valor) {
    if (!valor) return;
    return valor
        .replace(/[^\w\s]/gi, '')
        .replace(/(\w{2})(\w)/, '$1-$2')
        .replace(/(\w{7})(\w)/, '$1-$2')
        .replace(/(-\w{32})(\w)?/, '$1')
        .replace(/ /g, '')
        .toUpperCase();
}
function formatCodigoParcela(valor) {
    if (!valor) return;

    const string = valor.replace(/[^\w\s]/gi, '');

    const partes = [
        string.substring(0, 8),
        string.substring(8, 12),
        string.substring(12, 16),
        string.substring(16, 20),
        string.substring(20)
    ];
    return partes.join('-');
}

const numeralToCompactMonth = function (numeral) {
    numeral -= 1;

    const compactMonths = [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez'
    ];

    return compactMonths[numeral];
};

function formatarCuit(cuit) {
    if (!cuit) {
        return '-';
    }

    if (cuit.length !== 11) {
        return cuit;
    }

    return `${cuit.slice(0, 2)}-${cuit.slice(2, 10)}-${cuit.slice(10)}`;
}

const dateStringToDayName = function (dateString) {
    const days = [
        'Domingo',
        'Segunda',
        'Terça',
        'Quarta',
        'Quinta',
        'Sexta',
        'Sábado'
    ];
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return days[date.getDay()];
};

function reduzirCar(car) {
    if (typeof car !== 'string') return;
    if (car.length < 14) return;

    return car.slice(0, 9) + '...' + car.slice(car.length - 4);
}

function reduzirTexto(texto) {
    if (typeof texto !== 'string') return;
    if (texto.length < 18) return;

    return texto.slice(0, 9) + '...' + texto.slice(texto.length - 8);
}

function formatarTonelada(numero) {
    if (numero === null || numero === undefined || numero === '') return '0';

    numero = numero.toString().replace(/[^\d.,]/g, '');

    return numero;
}

function removerPontuacaoDocumento(input) {
    return input.replace(/[^\d]+/g, '');
}

export function capitalize(string) {
    if (!string || typeof string !== 'string') return null;
    return (
        string.substring(0, 1).toUpperCase() +
        string.substring(1).toLocaleLowerCase()
    );
}

const formatNumberIfDecimal = (input, decimalPlaces) => {
    if (!input) return '-';
    input = parseFloat(input);

    if (input <= Math.floor(input)) {
        return input;
    }

    return input.toLocaleString('pt-BR', {
        maximumFractionDigits: decimalPlaces,
        minimumFractionDigits: decimalPlaces
    });
};

const formatDate = function (unknownDate) {
    if (!unknownDate) return '-';
    let date;
    if (typeof unknownDate === 'string' && /^\d+$/.test(unknownDate)) {
        date = new Date(parseInt(unknownDate, 10));
    } else {
        date = new Date(unknownDate);
    }
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('pt-BR');
};

export default {
    formatNumber,
    maxFormatNumber,
    formatNumberUs,
    formatProdutividade,
    formatarCuit,
    cpfCnpjFormatToNumeral,
    numeralStringFormatTocpfCnpj,
    utf8Decode,
    formatCar,
    numeralStringFormatToDocumento,
    formatCodigoParcela,
    numeralToCompactMonth,
    dateStringToDayName,
    reduzirCar,
    formatarTonelada,
    removerPontuacaoDocumento,
    formatRoundProdutividade,
    capitalize,
    formatNumberIfDecimal,
    reduzirTexto,
    formatDate
};
